import { postJSON, getJSON } from "@js/helpers/communication.js";
import { getContent, getPreviewHashForContent } from "@js/helpers/state.js";
import randomInteger from "@js/helpers/random_integer.js";

export const CE_RENDER_PREVIEW_IMAGE_ERROR = "CE_RENDER_PREVIEW_IMAGE_ERROR";
export const ceRenderCycleError = (clientContentID, err) => ({
  type: CE_RENDER_PREVIEW_IMAGE_ERROR,
  client_content_id: clientContentID,
  error: err,
});

export const CE_RENDER_PREVIEW_IMAGE_WAITING_FOR_PUBLISH =
  "CE_RENDER_PREVIEW_IMAGE_WAITING_FOR_PUBLISH";
export const CE_RENDER_PREVIEW_IMAGE_REQUESTING_RENDER =
  "CE_RENDER_PREVIEW_IMAGE_REQUESTING_RENDER";
export const ceRequestNewRenderCycle = (clientContentID, previewHash) => (
  dispatch,
  getState,
) => {
  //First make sure we have our preview hash set. This won't update our step
  dispatch({
    type: CE_RENDER_PREVIEW_IMAGE_REQUESTING_RENDER,
    client_content_id: clientContentID,
  });

  let content = getContent(getState(), clientContentID);
  let url = Routes.request_new_render_path(getState().campaign_id, content.id);
  let data = {
    preview_hash: previewHash,
  };

  postJSON(url, data, (data, err) => {
    //Because we're in a thunk, this could have changes since we last read it
    let freshHash = getPreviewHashForContent(getState(), clientContentID);
    if (freshHash !== content.preview_image.preview_hash) {
      dispatch({
        type: CE_RENDER_PREVIEW_IMAGE_WAITING_FOR_PUBLISH,
      });
      return;
    }

    if (err) {
      dispatch(
        ceRenderCycleError(
          clientContentID,
          t(`phrases.react_content.unable_to_connect_for_preview`),
        ),
      );
      return;
    }

    if (!data.result || data.result !== "rendering") {
      dispatch(
        ceRenderCycleError(
          clientContentID,
          t(`phrases.react_content.unable_to_load_preview`),
        ),
      );
      return;
    }

    if (freshHash === content.preview_image.preview_hash) {
      dispatch(cePollRenderStatus(clientContentID, freshHash));
    }
    // else Implicit no-op, another render cycle will take care of this
  });
};

export const CE_RENDER_PREVIEW_IMAGE_WAIITNG_FOR_RENDER =
  "CE_RENDER_PREVIEW_IMAGE_WAIITNG_FOR_RENDER";
export const CE_RENDER_PREVIEW_IMAGE_READY = "CE_RENDER_PREVIEW_IMAGE_READY";
export const cePollRenderStatus = (clientContentID, previewHash) => (
  dispatch,
  getState,
) => {
  let state = getState();
  let content = getContent(state, clientContentID);

  if (content.preview_image.step !== "requesting_render") {
    dispatch({
      type: CE_RENDER_PREVIEW_IMAGE_WAIITNG_FOR_RENDER,
    });
  }

  let url = Routes.poll_for_render_path(state.campaign_id, content.id, {
    preview_hash: previewHash,
  });
  getJSON(url, (data, err) => {
    if (err || !data.result) {
      dispatch(
        ceRenderCycleError(
          clientContentID,
          t(`phrases.react_content.unable_to_connect_for_preview`),
        ),
      );
      return;
    }

    switch (data.result) {
      case "ready":
        let cacheBustedImage = `${data.image_url}?_=${randomInteger()}`; // This is necessary as IE will load a cached version of this otherwise
        dispatch({
          type: CE_RENDER_PREVIEW_IMAGE_READY,
          client_content_id: content.client_content_id,
          image_url: cacheBustedImage,
        });
        break;
      case "not_ready":
        let retry = () => {
          dispatch(cePollRenderStatus(clientContentID, previewHash));
        };
        window.setTimeout(retry, 1000);
        break;
      default:
        dispatch(
          ceRenderCycleError(
            clientContentID,
            t(`phrases.react_content.unable_to_load_preview`),
          ),
        );
    }
  });
};

export const CE_RENDER_PREVIEW_IMAGE_NO_CONTENT_TO_PREVIEW =
  "CE_RENDER_PREVIEW_IMAGE_NO_CONTENT_TO_PREVIEW";
export const ceRenderPreviewImageNoContentToPreview = (clientContentID) => ({
  type: CE_RENDER_PREVIEW_IMAGE_NO_CONTENT_TO_PREVIEW,
  client_content_id: clientContentID,
});
